import { apolloThemes } from "@nexthink/apollo-tokens";
// TODO should only get the colors and not the shadow, opacity, etc...
export const lightColors = apolloThemes.light;
export const darkColors = apolloThemes.dark;
//# sourceMappingURL=Colors.js.map